<span fxLayout="row">
    <span fxFlex="140px" class="inner-container" fxLayout="row" fxLayoutAlign="start center">
        <span class="inner-icon" fxFlex="30px">
            <app-icon-core [icon]="item.icon" [inline]="true"></app-icon-core>
        </span>
        <span fxFlex="90px" 
                class="inner-text"    
                matBadge="!"
                [matBadgeHidden]="!item.showBadge || item.submenuShow"
                matBadgeSize="small"
            >{{item.text}}</span>
    </span>
    <span fxFlex="40px" class="expand-icon">
        <span *ngIf="item.submenuItems.length > 0; else elseBlock">
            <app-icon-core icon="collapse-up" [inline]="true" *ngIf="item.submenuShow"></app-icon-core>
            <app-icon-core icon="expand-down" [inline]="true" *ngIf="!item.submenuShow"></app-icon-core> 
        </span>
        
    </span>
</span>


<ng-template #elseBlock>&nbsp;</ng-template>